import { combineEpics } from 'redux-observable';
import GlobalEpics from './Global';

export default combineEpics(
    GlobalEpics,
);
